import React from "react";
import { Helmet } from "react-helmet-async";

const SeoHelmet = ({ title, description, keywords }) => {
  return (
    <Helmet>
      <title>{title || "Transform With Bhavana | Personality & Style Coach"}</title>
      <meta
        name="description"
        content={description || "Transform your personality, confidence, and style with Bhavana Singh. Join offline, online, and one-on-one coaching programs designed to help you shine."}
      />
      <meta name="keywords" content={keywords || "Personal Transformation Coach, personality coach fashion coach"} />
    </Helmet>
  );
};

export default SeoHelmet;
